import { ContactShape } from "@eave/shared/types/api";
import React from "react";
import { Dropdown } from "carbon-components-react";

interface FilterByLMProps {
  loanManagersList: ContactShape[];
  selectedLM: string | null; // currently, LMs don't have unique IDs, so filter by email instead.
  updateSelectedLM: Function;
}

const styles = require("./styles.module.scss");

const FilterByLM: React.FC<FilterByLMProps> = ({
  loanManagersList,
  selectedLM,
  updateSelectedLM,
}: FilterByLMProps) => {
  const allLoanManagers = "All Loan Managers";

  // Helper function to retrieve the labelText
  const getDropdownLabelText = (): string => {
    if (!loanManagersList || selectedLM === "") {
      return allLoanManagers;
    }

    const selectedLoanManager = loanManagersList.find(lm => lm.name === selectedLM);
    if (!selectedLoanManager) {
      return allLoanManagers;
    }

    return selectedLoanManager.name;
  };

  return (
    <>
      {loanManagersList && (
        <Dropdown
          id="filter-by-loan-manager"
          type="inline"
          className={styles.lmFilter}
          titleText="Filter by Loan Manager:"
          label={getDropdownLabelText()}
          items={[{ name: allLoanManagers, value: "all" }, ...loanManagersList]}
          itemToString={item => (item ? item.name : "")}
          onChange={data => {
            const { selectedItem } = data;
            const { name } = selectedItem as ContactShape;

            // Update state & localStorage
            updateSelectedLM(name === allLoanManagers ? "all" : name);
            localStorage.setItem("TRUSSelectedLoanManager", name === allLoanManagers ? "" : name);
          }}
        />
      )}
    </>
  );
};

export default FilterByLM;
